"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _Icon = _interopRequireDefault(require("../../Icon"));

function getPrefix(a) {
  var b = a.prefix,
      c = a.size;
  return b ? "string" == typeof b ? _react["default"].createElement(_Icon["default"], {
    name: b,
    size: c
  }) : b : null;
}

var _default = getPrefix;
exports["default"] = _default;